import { type ErrorLink } from '@apollo/client/link/error'
import { isNil } from 'lodash'
import { useAuthorizationError } from './AuthorizationErrorContext'

export const useGraphQLErrorHandler = (customErrorHandler?: ErrorLink.ErrorHandler): ErrorLink.ErrorHandler => {
  const { showErrorDialog } = useAuthorizationError()

  return ({ operation, networkError, graphQLErrors, response, forward }) => {
    // Check for tenant provisioning errors
    let shouldShowTenantDialog = false

    if (!isNil(graphQLErrors)) {
      for (const err of graphQLErrors) {
        const errorCode = err.extensions?.code
        const errorMessage = err.message?.toLowerCase() || ''

        // Check for UNAUTHORIZED errors or NotFoundError related to tenant provisioning
        if (
          errorCode === 'UNAUTHORIZED' ||
          errorCode === 'NOT_FOUND' ||
          errorMessage.includes('tenant not found') ||
          errorMessage.includes('organization not found') ||
          errorMessage.includes('no tenant provisioned') ||
          errorMessage.includes('access denied')
        ) {
          shouldShowTenantDialog = true
          break
        }
      }
    }

    // If we detected a tenant provisioning error, show the dialog
    if (shouldShowTenantDialog) {
      showErrorDialog()

      // Prevent the default error handling (session revocation)
      return
    }

    // Otherwise, use the custom error handler if provided
    if (customErrorHandler) {
      customErrorHandler({ operation, networkError, graphQLErrors, response, forward })
    }
  }
}
